import React from "react";
import "./PaintFinishes.css";
import paint1 from "../assets/paint1.png";
import paint2 from "../assets/paint2.png";
import paint3 from "../assets/paint3.png";
import paint4 from "../assets/paint4.png";
import paint5 from "../assets/paint5.png";
import paint6 from "../assets/paint6.png";
import paint7 from "../assets/paint7.png";
import paint8 from "../assets/paint8.png";

const serviceAreas = [
  {
    id: "exterior",
    name: "Exterior Painting",
    image: paint1,
    desc: "Built to brave the elements, our exterior paints offer long-lasting protection and vibrant color. Whether you’re refreshing a façade or sealing a surface, our finishes resist fading, cracking, and moisture.",
  },
  {
    id: "interior",
    name: "Interior Painting",
    image: paint2,
    desc: "Transform your living spaces with finishes that blend elegance & durability. From matte calm to glossy brilliance, our interior paints are designed to reflect your style while standing up to everyday life—easy to clean, hard to ignore.",
  },
  {
    id: "base",
    name: "Base Preparation",
    image: paint3,
    desc: "A flawless finish starts with the right foundation. Our base preparation products ensure smooth adhesion, even coverage, and long-term performance. Prime your surfaces for success because great results begin beneath the surface.",
  },
  {
    id: "wood",
    name: "Wood Finishes",
    image: paint4,
    desc: "Celebrate the natural beauty of wood with finishes that protect & enhance. Whether you’re staining, sealing, or polishing, our wood solutions offer rich tones, lasting durability, and a touch of craftsmanship in every coat.",
  },
  {
    id: "metal",
    name: "Metal Finishes",
    image: paint5,
    desc: "Shield your metal surfaces with finishes that fight rust, wear & weather. From industrial-grade coatings to decorative sheens, our metal paints combine strength with style—perfect for gates, grills, and more.",
  },
  {
    id: "industrial",
    name: "Industrial Finishes",
    image: paint6,
    desc: "Engineered for performance, our industrial finishes meet the demands of heavy-duty environments. Resistant to chemicals, abrasion, and extreme conditions, they’re ideal for factories, machinery, and infrastructure.",
  },
  {
    id: "special",
    name: "Special Finishes",
    image: paint7,
    desc: "Add character and creativity with our range of special finishes from textured effects to metallic sheens. Designed to make a statement, these paints turn ordinary surfaces into standout features with flair and function.",
  },
  {
    id: "expert",
    name: "Expert Labour",
    image: paint8,
    desc: "Quality paint deserves expert hands. Our skilled labour partners bring precision, professionalism, and passion to every project ensuring your vision is executed flawlessly, from prep to final stroke.",
  },
];

const finishTypes = [
  {
    title: "Royal Interior Silk Emulsion",
    description:
      "Designed for interior walls, Master Royal Exterior Silk delivers a rich, velvety-matte appearance with added strength and excellent scrubbability.",
  },
  {
    title: "Royal Matt",
    description:
      "Master Interior Royal Matt Finish delivers a rich, velvety-matte appearance with added strength and excellent scrubbability.",
  },
  {
    title: "Synthetic Enamel",
    description:
      "Master Synthetic Enamel provides a glossy, long-lasting finish that resists UV rays and chemicals, making it the preferred choice for areas exposed to weathering. Ideal for both protection and shine, indoors or outdoors.",
  },
  {
    title: "Super Emulsion",
    description:
      "Master Paints Super Emulsion features a durable, smooth, easy-to-clean finish. It’s the perfect choice for high-traffic areas and versatile enough for both interior and exterior use.",
  },
];

const PaintFinishes = () => {
  return (
    <div className="paint-finishes-container">
      <h2 className="mobile-team-title">Our Expert Team</h2>
      <div className="image-grid">
        {serviceAreas.map((item, index) => (
          <div key={index} className={`grid-item ${item.id}`}>
            <img src={item.image} alt={item.name} className="grid-img" />
            <div className="label-overlay">{item.name}</div>
            <div className="hover-overlay">
              <h3>{item.name}</h3>
              <p>{item.desc}</p>
              <button className="btn-know-more">Know More</button>
            </div>
          </div>
        ))}
      </div>
      <div className="finishes-info">
        <div className="info-card">
          <h2 className="card-title">Types of Finishes</h2>
          <p className="card-description">
            We offer a wide variety of finishes to match every style and
            requirement. From smooth, non-shiny matt finishes to slightly
            lustrous stain finishes, durable semi-gloss options, and high-gloss
            reflective coatings — our collection caters to diverse needs across
            various industries and design preferences.
          </p>
          <div className="finish-list">
            {finishTypes.map((finish, index) => (
              <div key={index} className="finish-item">
                <h3 className="finish-item-title">{finish.title}</h3>
                <p className="finish-item-description">{finish.description}</p>
              </div>
            ))}
          </div>
          <div className="cta-buttons">
            <button className="cta-button primary">Order Your Paint Now</button>
            <button className="cta-button secondary">Learn More</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaintFinishes;
